import { MemberAnketaSubquestionsProgression } from './MemberAnketaSubquestionsProgression';

export default MemberAnketaSubquestionsProgression;